import FundLayout from 'layout/fund/FundLayout'
import { RouteObject } from 'react-router-dom'
import DetailAddMoneyPool from './moneyPool/detail'
import MemberShip from './moneyPool/memberShip'
import Manage from './moneyPool/manage'
import Transparency from './moneyPool/manage/transparency'
import SendMessages from './moneyPool/manage/sendMessages'
import ManagerRecords from './moneyPool/managerRecord'
import AddNewLoan from './moneyPool/addNewLoan'
import EditNewLoan from './moneyPool/editLoan'
import ErrorBug from 'components/errors/bugs'

export const addBox: RouteObject[] = [
    {
        path: 'add-box',
        element: <FundLayout helmet="ایجاد صندوق" />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: 'moneyPool',
                element: <DetailAddMoneyPool />,
            },
            {
                index: false,
                path: 'memberShip',
                element: <MemberShip />,
            },
            {
                index: false,
                path: 'manage',
                element: <Manage />,
            },
            {
                index: false,
                path: 'transparency',
                element: <Transparency />,
            },
            {
                index: false,
                path: 'send-message',
                element: <SendMessages />,
            },
            {
                index: false,
                path: 'manager-records',
                element: <ManagerRecords />,
            },
            {
                index: false,
                path: 'manager-records/new-loan',
                element: <AddNewLoan />,
            },
            {
                index: false,
                path: 'manager-records/edit-loan',
                element: <EditNewLoan />,
            },
        ],
    },
]
